import React from "react";

import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Typography } from "@mui/material";

interface EmptyPortalIntegrationsProps {
  onAddIntegration: () => void;
}

export const EmptyPortalIntegrations: React.FC<EmptyPortalIntegrationsProps> = ({ onAddIntegration }) => {
  return (
    <Box
      sx={{
        bgcolor: "#f6f8fc",
        border: "1px solid #dbe8f5",
        borderRadius: "8px",
        p: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px"
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 400,
          color: "#071f35",
          lineHeight: "24px",
          textAlign: "center",
          whiteSpace: "normal"
        }}
      >
        Easily plug in and sync all your assets into a single, streamlined location
      </Typography>
      <Button
        variant="outlined"
        startIcon={<AddIcon sx={{ fontSize: "20px" }} />}
        onClick={onAddIntegration}
        sx={{
          borderColor: "#7b92a9",
          color: "#071f35",
          fontSize: "16px",
          fontWeight: 400,
          textTransform: "none",
          borderRadius: "32px",
          px: "16px",
          py: "4px",
          minWidth: "auto",
          height: "auto",
          mt: "10px",
          "&:hover": {
            borderColor: "#071f35",
            backgroundColor: "transparent"
          }
        }}
      >
        Add integration
      </Button>
    </Box>
  );
};
